import React, { useState } from "react";
import { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form"

//import axios from 'axios';
import axios_api from "../../Api";

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../../Context';


export function DocumentForm ({orderformFilename, contractFilename, year}) {
  const [orderformFileSelected, setOrderformFileSelected] = useState(false);
  const [contractFileSelected, setContractFileSelected] = useState(false);
  //const media_url = useContext(MEDIA_URL);
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();
  const [formError, setFormError] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });


  const onSubmit = (fileData) => {

    let params = {'year': year, 'operation': 'upload-signed-documents'};
    let data = {...fileData, ...params};

    console.log(data);

    axios_api.put(api_url + `/order`, data, {
      //paramsSerializer: { indexes: null },
      headers: {
        "Authorization": token, 
        "Content-Type": "multipart/form-data",
      }
    })
    .then(
      (result) => {
        console.log("Document uploaded");
        navigate("/order");
        navigate(0);
      },
      (error) => {
        setFormError(error.response.data)
        //console.log(error);
      }
    );
  }


  return (
    <>
    <div className="lk-form">
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">

        <div 
          className="modal fade modal-xs" 
          id="confirmDocumentSendModal" 
          tabIndex="-1" 
          aria-labelledby="confirmDocumentSendModalLabel" 
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-scrollable modal-xs">
            <div className="modal-content">
              <div className="modal-header bg-light">
                <h2 className="modal-title fs-5" id="confirmOrderSendModalLabel">Документ</h2>
                <button type="button" className="btn-close me-3" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <p className="m-4 fs-5 text-center"  style={{'fontWeight': '500'}}>Вы уверены, что хотите отправить подписанный документ в АСНП ЦВКК?</p>    
              </div>
              <div className="modal-footer justify-content-between">
                <button 
                  type="button" 
                  className="btn btn-secondary lk-bootstrap-button" 
                  data-bs-dismiss="modal">
                    Отмена
                </button>
                <button 
                  type="submit" 
                  className="btn lk-button" 
                  data-bs-dismiss="modal" 
                  aria-label="Close" 
                  onClick={() => {handleSubmit(onSubmit)}}>
                    Отправить документ
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="input-group mt-3">
          <label className="">
            <p>Скан подписанного бланка заказа</p>
            <input type="file" className="form-control" style={{width: '400px'}} {...register(orderformFilename)} onChange={(e) => setOrderformFileSelected(true)}/>
          </label>
        </div>
        <p className="text-secondary mt-1"><small>максимальный размер файла 10 мб</small></p>
        { formError.message && formError.field === 'order_form' &&
          <p className="text-danger">{formError.message}</p>
        }
        <div className="input-group mt-3">
          <label className="">
            <p>Скан подписанного договора</p> 
            <input type="file" className="form-control" style={{width: '400px'}} {...register(contractFilename)} onChange={(e) => setContractFileSelected(true)}/>
          </label>
        </div>
        <p className="text-secondary mt-1"><small>максимальный размер файла 10 мб</small></p>
        { formError.message && formError.field === 'contract' &&
          <p className="text-danger">{formError.message}</p>
        }
        {(orderformFileSelected === true && contractFileSelected === true) ?
          <button type="button" className="btn lk-button my-3" data-bs-toggle="modal" data-bs-target="#confirmDocumentSendModal" aria-label="Close" >Отправить</button>
        :
          <button type="button" className="btn lk-button my-3" disabled>Отправить</button>
        }
      </form>
    </div>
    </>  
  )
}